import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  useGetClinicsQuery,
  useDeleteClinicMutation,
} from "slices/wellness/clinicSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";

function Clinics() {
  const naviagte = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteClinicMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, refetch } = useGetClinicsQuery({
    page,
    limit,
    search,
  });
  const col = [
    {
      display: "Image",
      key: "image",
      type: "image",
      style: {
        borderRadius: "50%",
        height: "80px",
        width: "80px",
        objectFit: "cover",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
      },
    },
    { display: "Name", key: "name", type: "display" },
    { display: "Mobile", key: "mobile", type: "display" },
    { display: "Email", key: "email", type: "display" },
  ];

  const canEdit = hasActionAccess(auth, "Wellness", "Clinics", "view");
  const canDelete = hasActionAccess(auth, "Wellness", "Clinics", "delete");

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>View</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }
  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    naviagte(`/wellness/clinics/view-clinic/${row._id}`);
  };

  const handleAdd = () => {
    naviagte("/wellness/clinics/add-clinic");
  };
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this clinic?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const canAdd = hasActionAccess(auth, "Wellness", "Clinics", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Clinic
        </Button>
      )}

      <Tables
        title={"Clinics"}
        handleSearch={handleSearchChange}
        totalPages={data?.data?.pagination?.totalPages}
        data={data?.data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Clinics;
